import {useEffect, useState} from 'react';
import {getDocumentSegmentsWithHtml} from '../../../utils/api/document';

// Handles HTML/text mode + fetching HTML segments for a document.
// Contract:
// - default viewMode is 'html' when hasHTML is true, else 'text'
// - fetches html segments once per document when switching to html mode
// - aborts in-flight request on doc/mode change or unmount
export default function useDocumentHtmlView(documentId, hasHTML) {
    const [viewMode, setViewMode] = useState(() => (hasHTML ? 'html' : 'text')); // 'text' | 'html'
    const [htmlSegments, setHtmlSegments] = useState(null);
    const [loadingHtml, setLoadingHtml] = useState(false);

    // Load HTML segments when switching to HTML view
    useEffect(() => {
        if (viewMode === 'html' && documentId && !htmlSegments) {
            setLoadingHtml(true);
            const controller = new AbortController();

            getDocumentSegmentsWithHtml(documentId, controller.signal)
                .then((segments) => {
                    setHtmlSegments(segments);
                })
                .catch((error) => {
                    if (error?.name !== 'AbortError') {
                        // keep behavior: log but don't throw
                        // eslint-disable-next-line no-console
                        console.error('Error fetching HTML segments:', error);
                    }
                })
                .finally(() => {
                    setLoadingHtml(false);
                });

            return () => controller.abort();
        }
    }, [viewMode, documentId, htmlSegments]);

    // Reset HTML segments when document changes + re-derive default view mode
    useEffect(() => {
        setHtmlSegments(null);
        setViewMode(hasHTML ? 'html' : 'text');
    }, [documentId, hasHTML]);

    return {viewMode, setViewMode, htmlSegments, loadingHtml};
}

